export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api/v1.0',
  TIMEOUT: 2400000,
  HEADERS: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
}
